import _ from "lodash";
import { useQuery } from "@apollo/client";
import { useHostStore } from "host/HostStore";
import { initializeAppContext } from "./AppInitializer";
import AppContext from "store/context/AppContext/AppContext";
import React, { useContext, useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { httpLinkConfigurator } from "store/graphql/apollo/clients";
import RouteContainer from "container/Layout/RouteContainer/RouteContainer";
import { GetEnvironmentsForProductDocument } from "store/graphql/codegen/auto-gen/environment";
import { GetUserDocument } from "store/graphql/codegen/auto-gen/user";
import { clarity } from "clarity-js";
import "./index.scss";
import { EntitlementsProvider } from "store/context/EntitlementsContext/EntitlementsContext";

const queryClient = new QueryClient();

const UPLOAD_URL = "https://m.clarity.ms/collect";

export const App = () => {
    const PROJECT_ID: string = process.env.PROJECT_ID || "";
    const [appInitialized, setAppInitialized] = useState(false);
    const { auth, setAuth, setEnvironment } = useHostStore();
    const appCtx = useContext(AppContext);

    const {
        data: userData,
        loading: userDataLoading,
        error: userDataError,
        refetch: refetchGetUser
    } = useQuery(GetUserDocument, {
        variables: {
            userId: localStorage.getItem("userDetails")
        },
        fetchPolicy: "no-cache"
    });

    const {
        data: getEnvironmentsForProductData,
        loading: getEnvironmentsForProductLoading,
        error: getEnvironmentsForProductError,
        refetch: refetchGetEnvironmentsForProduct
    } = useQuery(GetEnvironmentsForProductDocument, {
        client: httpLinkConfigurator,
        variables: {
            input: {
                productId: localStorage.getItem("productId"),
            }
        },
        fetchPolicy: "no-cache"
    });

    function logProductAndEnvId() {
        console.log("watching from hostUI productId: ", localStorage.getItem("productId"), " and environmentId: ", localStorage.getItem("environmentId"));
    }

    useEffect(() => {
        console.log("adding event listener for productId in hostUI");
        window.addEventListener('storage', logProductAndEnvId, false);
    }, []);

    useEffect(() => {
        if (
            !_.isEmpty(userData) &&
            !_.isEmpty(getEnvironmentsForProductData) &&
            !userDataLoading &&
            !appInitialized
        ) {
            initializeAppContext(
                userData.getUser,
                getEnvironmentsForProductData?.getEnvironmentsForProduct?.environments,
                setAuth,
                setEnvironment
            );
            setAppInitialized(true);
        }
    }, [
        userData,
        getEnvironmentsForProductData,
        userDataLoading,
        getEnvironmentsForProductLoading,
        appInitialized
    ]);

    useEffect(() => {
        console.log("clarity", PROJECT_ID);
        clarity.consent();
        clarity.start({
            projectId: 'lrqe9t0g22',
            upload: UPLOAD_URL,
            track: true,
            content: true,
            cookies: []
        });
        return () => {
            clarity.stop();
        };
    }, []);

    useEffect(() => {
        if (appCtx.executeOnBoardingCompleteCheck) {
            refetchGetUser();
            refetchGetEnvironmentsForProduct();
            setAppInitialized(false);
        }
    }, [appCtx.executeOnBoardingCompleteCheck]);

    return (
        <QueryClientProvider client={queryClient}>
            <EntitlementsProvider>
                <div className="flex flex-col h-full md:h-screen">
                    <RouteContainer />
                </div>
            </EntitlementsProvider>
        </QueryClientProvider>
    );
};
